import React from 'react';
import { Format } from './MapArticle';

const CountryDetail = (props) => {
  return <>{props.content.map(Format)}</>;
};

export default CountryDetail;
